export function sleep(ms: number) {
  return new Promise((r) => setTimeout(r, ms));
}

export function clamp(n: number, a: number, b: number) {
  return Math.max(a, Math.min(b, n));
}

export function formatNumber(n: number) {
  const parts = n.toFixed(2).split(".");
  const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${int}.${parts[1]}`;
}

export function formatSigned(n: number, digits = 2) {
  const s = n >= 0 ? "+" : "";
  return `${s}${n.toFixed(digits)}`;
}

export function fmtPct(n: number, digits = 2) {
  const s = n >= 0 ? "+" : "";
  return `${s}${n.toFixed(digits)}%`;
}


